// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1nAeT","range":"MonthRangeSwitch_range__13wLI","disabled":"MonthRangeSwitch_disabled__1c587"};